import { ApiResult, CrudService, Meta } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IDENTIDADE_API_URL, OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";
import {
    ContaUsuarioConsulta,
    UsuarioEntity,
    UsuarioPerfilEntity,
    UsuarioUnidadeNegocioEntity
} from '@catalogo/models/operacional';

@Injectable({ providedIn: 'any' })
export class UsuarioDataService extends CrudService<UsuarioEntity> {
    protected url: string;
    protected urlIdentidade: string;
    protected urlOperacao: string;

    constructor(
        @Inject(IDENTIDADE_API_URL) urlIdentidade: string,
        @Inject(OPERACAO_API_URL) urlOperacao: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlIdentidade, httpClient);
        this.urlIdentidade = `${urlIdentidade}/v1/conta/<id>/usuario/consulta`;
        this.urlOperacao = `${urlOperacao}/v1/Usuario`;
    }

    public getUsuarios(meta: Meta) {
        this.url = this.urlOperacao;
        return this.getWithQuery(meta);
    }

    public getById = (id: string) =>
        this.httpClient.get<ApiResult<UsuarioEntity>>(`${this.urlOperacao}/${id}`);
    public getDetalhes = () =>
        this.httpClient.get<ApiResult<UsuarioEntity>>(`${this.urlOperacao}/detalhes`);
    // A conta é a conta em uso no token.
    public getUsuarioContaIdentidade = (usuarioId: string) =>
        this.httpClient.get<ApiResult<ContaUsuarioConsulta>>(`${this.urlBase}/v1/conta/usuario/${usuarioId}/consulta`);
    public getPerfisUsuario = (usuarioId: string) =>
        this.httpClient.get<ApiResult<UsuarioPerfilEntity[]>>(`${this.urlOperacao}/${usuarioId}/Perfis`);
    public salvarPerfis = (perfis: UsuarioPerfilEntity[], usuarioId: string) =>
        this.httpClient.post<ApiResult<boolean>>(`${this.urlOperacao}/${usuarioId}/Perfis`, { usuarioId, perfis });
    public salvarUnidadesNegocio = (unidades: UsuarioUnidadeNegocioEntity[], usuarioId: string) =>
        this.httpClient.post<ApiResult<boolean>>(`${this.urlOperacao}/${usuarioId}/Unidades`, { usuarioId, unidades });
    public bloquearAcesso = (email: string, ambiente: string) =>
        this.httpClient.post<ApiResult<boolean>>(this.url + `/BloquearAcesso`, { email, ambiente });
    public desbloquearAcesso = (email: string, ambiente: string) =>
        this.httpClient.post<ApiResult<boolean>>(this.url + `/DesbloquearAcesso`, { email, ambiente });
    public obterUsuarioNotificacaoConfiguracao = () =>
        this.httpClient.get<ApiResult<any>>(`${this.urlOperacao}/Notificacao/Configuracao`);
    public adicionarUsuarioNotificacaoConfiguracao = (configuracao: any) =>
        this.httpClient.post<ApiResult<any>>(`${this.urlOperacao}/Notificacao/Configuracao`, configuracao);
    public convidar = (usuario: UsuarioEntity, ambiente: string) =>
        this.httpClient.post<ApiResult<boolean>>(this.url + `/Convidar`, {
            nome: usuario.nome,
            email: usuario.email,
            ambiente
        });
    public adicionarPerfis = (perfis: UsuarioPerfilEntity[]) =>
        this.httpClient.post<ApiResult<boolean>>(`${this.urlOperacao}/Perfis`, { perfis });
    public removerPerfis = (perfis: UsuarioPerfilEntity[]) =>
        this.httpClient.put<ApiResult<boolean>>(`${this.urlOperacao}/Perfis`, { perfis });

    public removerUnidades = (unidades: UsuarioUnidadeNegocioEntity[]) =>
        this.httpClient.put<ApiResult<boolean>>(`${this.urlOperacao}/Unidades`, { unidades });

    public adicionarUnidades = (unidades: UsuarioUnidadeNegocioEntity[]) =>
        this.httpClient.post<ApiResult<boolean>>(`${this.urlOperacao}/Unidades`, { unidades });
}
